<template>
  <div class="page-content">
    <page-template ref="salesTemplate"
                   :tableOptions="tableOptions"
                   :searchOptions="searchOptions"
                   :toolConfig="toolConfig"
                   :detailColumns="detailColumns"
    ></page-template>
  </div>
</template>

<script>
  import pageTemplate from '@/components/template/pageTemplate';
  import api from '@/config/api';
  import date from '@/mixin/date'

  export default {
    mixins: [date],
    components: {
      pageTemplate,
    },
    data() {
      return {
        // 高级搜索条件
        searchOptions: {
          simple: [
            {
              label: "",
              type: "input",
              prop: "orderNo",
              span: 12,
              placeholder: "请输入业务单号"
            },
          ],
          complex: [
            {
              label: '选择日期',
              prop: 'CreateDttm',
              type: 'dateTimeRangeButton',
              dateType: 'datetime',
              span: 24
            },
            // {
            //   label: "供应商",
            //   type: "select",
            //   prop: "supplierId",
            //   data: [],
            //   span: 12,
            //   url: api.archives.supplier,
            //   param: {type: 10},
            // },
            {
              label: "门店名称",
              type: "select",
              prop: "storeId",
              data: [],
              isHasAll: true,
              span: 12,
              change: this.getCustomerChange,
              defaultValue: this.$utils.getSysUser().storeId,
              url: api.system.seStore,
            },
            {
              label: "客户",
              type: "select",
              prop: "customerId",
              span: 12,
              data: [],
              // url: api.wholesale.archives
            },
            {
              label: '审核状态',
              prop: 'reviewerStatus',
              type: 'select',
              defaultValue: 20,
              span: 12,
              data: [{label: '未审核', value: 20}, {label: '已审核', value: 10}],
            },
          ]
        },
        // 更多功能
        toolConfig: [
          {
            label: '新增',
            code: 'insert',
            callback: this.addRequisition
          },
          {
            label: '打印',
            code: 'print',
            filter: () => {
              return false
            }
          },
          {
            label: '导出',
            code: 'export',
            filter: () => {
              return false
            }
          },
          {
            label: '编辑',
            type: this.$utils.buttonType.tableOperate,
            code: 'update',
            callback: this.toEditPage,
            filter: (data) => {
              return data.reviewerStatus == 10 ? false : true;
            }
          },
          {
            label: '删除',
            code: 'delete',
            type: this.$utils.buttonType.tableOperate,
            filter: (data) => {
              return data.reviewerStatus == 10 ? false : true;
            }
          },
        ],
        // 表格信息配置
        tableOptions: {
          tableName: 'clearTable',
          showSelect: true,
          indexShow: true,//是否显示索引
          columns: [
            {
              label: '业务单号',
              prop: 'orderNo',
              width: '230',
              align: 'center',
              // showDetail: true
              callback: this.goOrderDetail
            },
            {label: '门店名称', prop: 'storeName', width: '150', align: 'center'},
            // {label: '客户编码', prop: 'customerCode', width: '150', align: 'center'},
            {label: '客户名称', prop: 'customerName', width: '190', align: 'center'},
            {
              label: '状态',
              prop: 'reviewerStatus',
              width: '120',
              align: 'center',
              enumData: this.$utils.getCacheStatus('wlWholesaleOrder.reviewerStatus')
            },
            {label: '单据金额', prop: 'billAmount', width: '120', align: 'center'},
            {label: '制单人', prop: 'voucherName', width: '120', align: 'center'},
            {label: '制单日期', prop: 'voucherDttm', width: '150', align: 'center'},
            {label: '审核人', prop: 'reviewerName', width: '120', align: 'center',},
            {label: '审核日期', prop: 'reviewerDttm', width: '150', align: 'center',},
            {label: '备注', prop: 'remarks', width: '120', align: 'center',},
          ],
          param: {reviewerStatus: 20, stCreateDttm: this.getStMonthDate(), edCreateDttm: this.getEdMonthDate(),},
          url: api.settle.settlementCustomer
        },
        detailColumns: {
          statusOption: {
            prop: 'reviewerStatus',
            statusImg: {
              10: '/static/checked.png',
              20: '/static/un-check.png'
            },
            right: '200px',
            top: '30px',
          },
          span: 8,
          labelWidth: "130",
          columns: [
            {
              label: '业务单号',
              prop: 'orderNo',
            }, {
              label: '客户',
              prop: 'customerName',
            }, {
              label: '门店',
              prop: 'storeName',
            },
            {
              label: '付款方式',
              prop: 'payType',
              enumData: this.$utils.getCacheStatus("stCustomerSettlementOrder.payType"),
            },
            {
              label: '付款金额',
              prop: 'billAmount',
            },
            {
              label: '备注',
              prop: 'remarks',
            }
          ],
          tablesProp: {
            stCustomerSettlementMapList: {
              url: api.settle.customerSettlementMap + "/page",
              showSummary: true,
              indexShow: true,
              height:this.detailHeight,
              tableName: "stCustomerSettlementMapList",
              summaryColumns: ['payAmount', 'amountPaid', 'discountedAmount', 'outstandAmount', 'actualPayAmount', 'discountMoney'],
              columns: [
                {
                  label: '单据号',
                  prop: 'wholesaleOrderNo',
                  width: '220',
                  align: "center",
                },
                {
                  label: "单据类型",
                  prop: "wholesaleType",
                  width: '120',
                  align: "center",
                  enumData: this.$utils.getCacheStatus('stCustomerSettlementMap.wholesaleType')
                },
                {
                  label: "单据日期",
                  prop: "billDttm",
                  width: '180',
                  align: "center"
                },
                {
                  label: '对账单号',
                  prop: 'billOrderNo',
                  width: '220',
                  align: "center",
                },
                {
                  label: '应收金额',
                  width: '90',
                  prop: 'payAmount',
                  align: "center",
                },
                {
                  label: '已收金额',
                  width: '125',
                  prop: 'amountPaid',
                  align: "center"
                },
                {
                  label: '已优惠金额',
                  width: '120',
                  prop: 'discountedAmount',
                  align: "center"
                },
                {
                  label: '未收金额',
                  width: '90',
                  prop: 'outstandAmount',
                  align: "center"
                },
                {
                  label: '实收金额',
                  width: '90',
                  prop: 'actualPayAmount',
                  align: "center",
                  precision: 2
                },
                {
                  label: '优惠金额',
                  width: '90',
                  prop: 'discountMoney',
                  align: "center",
                  precision: 2
                },
                {
                  label: '备注',
                  prop: 'remarks',
                  width: '90',
                  align: "center"
                },
              ],
            },
          },

          // 打印的列表
          printTablesProp: {
            stCustomerSettlementMapList: {
              tableName: 'stCustomerSettlementMapList',
              showSummary: true,
              summaryColumns: ['payAmount'],
              columns: [
                {
                  label: '序号',
                  prop: 'indexShow',
                  width: '50',
                  align: "center"
                },
                {
                  label: '单据号',
                  prop: 'wholesaleOrderNo',
                  width: '220',
                  align: "center",
                },
                {
                  label: "单据类型",
                  prop: "wholesaleType",
                  width: '120',
                  align: "center",
                  enumData: this.$utils.getCacheStatus('stCustomerSettlementMap.wholesaleType')
                },
                {
                  label: "单据日期",
                  prop: "billDttm",
                  width: '180',
                  align: "center"
                },
                {
                  label: '对账单号',
                  prop: 'billOrderNo',
                  width: '220',
                  align: "center",
                },
                {
                  label: '应收金额',
                  width: '90',
                  prop: 'payAmount',
                  align: "center",
                },
                {
                  label: '已收金额',
                  width: '125',
                  prop: 'amountPaid',
                  align: "center"
                },
                {
                  label: '已优惠金额',
                  width: '120',
                  prop: 'discountedAmount',
                  align: "center"
                },
                {
                  label: '未收金额',
                  width: '90',
                  prop: 'outstandAmount',
                  align: "center"
                },
                {
                  label: '实收金额',
                  width: '90',
                  prop: 'actualPayAmount',
                  align: "center",
                  precision: 2
                },
                {
                  label: '优惠金额',
                  width: '90',
                  prop: 'discountMoney',
                  align: "center",
                  precision: 2
                },
                {
                  label: '备注',
                  prop: 'remarks',
                  width: '90',
                  align: "center"
                },
              ],
            },
          },
          url: api.settle.settlementCustomer
        }
      };
    },
    beforeCreate() {
      this.detailHeight = document.documentElement.clientHeight - 180 - 200
    },
    created() {
      this.storeDefault()
    },
    mounted() {
      if (Object.keys(this.$route.params).length > 0) {
        if (this.$route.params.customQuery) {
          let str = this.$route.params.customQuery
          this.tableOptions.param = eval('(' + str + ')')
        }
      }
      // this.$nextTick(()=>{
      //   this.tableOptions.url = api.settle.settlementCustomer
      //   this.$refs['salesTemplate'].operationSuccess();
      // })
    },
    methods: {
      storeDefault() {
        if (this.$utils.getSysUser().storeId) {
          this.searchOptions.complex.filter(item => item.prop === 'storeId')[0].disabled = true;
        }
      },
      getCustomerChange(form) {
        form.customerId = '';
        this.searchOptions.complex.filter(item => item.prop === 'customerId')[0].data = [];
        this.$axios.fetchPost(api.wholesale.archives + "/list", {storeId: form.storeId}).then(data => {
          if (data.code === 200) {
            this.searchOptions.complex.filter(item => item.prop === 'customerId')[0].data = data.data;
          }
        })
      },
      goOrderDetail(row) {
        this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, this.detailColumns);
        this.$router.push({
          path: '/settlement/customer/detail?id=' + row.id,
          query: {redirect: '/settlement/customer'}
        }).catch(err => {
        });
      },
      toEditPage(row) {
        this.$router.push({path: '/settlement/customer/add?id=' + row.id}).catch(err => {
        });
      },
      addRequisition() {
        this.$router.push({path: '/settlement/customer/add'});
      },
    }
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/settle/customer/SettlementCustomer.vue